import {getCookie} from './cookie';
import Message from 'base/message/message';
import axios from 'axios';
import {clearUser, goLogin} from 'common/js/util';

const ERR_OK = '200';
const ERR_TIME_OUT = '4';

const message = new Message();

export default function fetch(code, param) {
  const url = '/api' + code;
  const data = {
    ...param
  };

  param = JSON.stringify(data);
  let locale = window.localStorage.getItem('user_lang');
  let token = localStorage.getItem('access_token');
  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization':JSON.parse(token) || '',
      "Accept-Language": locale === 'en_US' ? 'en_US' : 'zh_CN'
    },
    url: url,
    data: param
  }).then((res) => {
    res = res.data;
    if (res.errorCode === ERR_TIME_OUT) {
      message.show('登录超时，请重新登录');
      clearUser();
      setTimeout(() => {
        goLogin();
      }, 800);
      return Promise.reject('timeout');
    }
    if(res.errorCode === 'A50004') {
      message.show('登录超时，请重新登录');
      clearUser();
      setTimeout(() => {
        goLogin();
      }, 800);
      return Promise.reject('timeout');
    }
    if(res.code !== ERR_OK) {
      if (res.errorInfo) {
        message.show(res.errorInfo.toString());
      } else if(res.errorMsg) {
        message.show(res.errorMsg.toString());
      } else {
        message.show(res.errorMsg || '操作失败');
      }
      return Promise.reject(res.errorInfo);
    }
    return Promise.resolve(res.data);
  });
}



// WEBPACK FOOTER //
// ./src/common/js/fetch.js